<section>
  <div class="content-2">
    <div class="title-container">
      <h1 class="title">Docentes: formação e remuneração</h1>
      <h2 class="subtitle">
        Informe os níveis do plano de carreira e o percentual de professores em cada nível com a respectiva formação e remuneração.
      </h2>
    </div>

    <hr class="division-line" />

    <div class="dropdown-panel panel">
      <app-menu-suspenso
        #menuTooltip="matTooltip"
        [matTooltip]="menuTooltipVisible ? 'Visualizar o PQR' : ''"
        matTooltipPosition="above"
        [opcoes]="[
          {
            rotulo: 'PQR desta funcionalidade',
            icone: 'computer',
            acao: 'pqrDestaFuncionalidade'
          },
          {
            rotulo: 'Restaurar valores com base no PQR',
            icone: 'content_copy',
            acao: 'restaurarValoresComBaseNoPqr'
          },
          {
            rotulo: 'PQR completo em nova aba',
            icone: 'desktop_windows',
            acao: 'pqrCompletoEmNovaAba'
          }
        ]"
        (chamadaDeAcao)="chamarAcao($event)"
      >
        Padrão de qualidade de referência (PQR)
      </app-menu-suspenso>

      <mat-icon
        (mouseenter)="openTooltips()"
        (mouseleave)="closeTooltips()"
        class="info-icon"
        #infoTooltip="matTooltip"
        matTooltip="Informações sobre o PQR"
        matTooltipPosition="left"
      >
        info
      </mat-icon>
    </div>

    <div class="panel">
      <div class="table-wrapper">
        <app-tabela
          ngSkipHydration
          class="table-component"
          [cabecalhoCustomizado]="true"
        >
          <ng-container cabecalho>
            <tr>
              <th class="table-header" rowspan="2" style="width: 2%">
                <button
                  mat-icon-button
                  class="botao-adicionar diminui-botao"
                  (click)="adicionarProfessores()"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </th>
              <th class="table-header" colspan="2" style="width: 10%">
                Nível / Classe
              </th>
              <th class="table-header" rowspan="2" style="width: 11%">
                Nível de Informação <sup>(1)</sup>
              </th>
              <th class="table-header" colspan="3" style="width: 10%">
                Jornada
              </th>
              <th class="table-header" colspan="2" style="width: 10%">
                Remuneração bruta mensal
              </th>
              <th class="table-header" rowspan="2" style="width: 8%">
                Mês/ano referência
              </th>
              <th class="table-header" rowspan="2" style="width: 8%">
                Número de professores {{anoCenso}} <sup>(2)</sup> <sup> (3)</sup>
              </th>
              <th class="table-header" rowspan="2" style="width: 2%">%</th>
              <th class="table-header" colspan="1" style="width: 13%">
                Distribuição do número de professores nos níveis da carreira em
                cada ano do plano (%)
              </th>
            </tr>
            <tr>
              <th class="table-header" style="width: 3%">Seq.</th>
              <th class="table-header" style="width: 8%">Denominação</th>
              <th class="table-header" style="width: 9%">
                Jornada total (em horas)
              </th>
              <th class="table-header" style="width: 9%">Sem interação (%)</th>
              <th class="table-header" style="width: 9%">Com interação (%)</th>
              <th class="table-header" colspan="2" style="width: 13%">PQR (R$)</th>
              <th class="table-header" style="width: 10%">{{anoPqr}}</th>
            </tr>
          </ng-container>
          <ng-container corpo>
            <ng-container *ngFor="let professores of dadosTabela">
              <tr>
                <td class="table-cell">
                  <button
                    mat-icon-button
                    class="botao-excluir diminui-botao"
                    (click)="excluiProfessores(professores.pqr.codPqrFormacaoJornadaRemuneracaoProfessores)"
                  >
                    <mat-icon> close </mat-icon>
                  </button>
                </td>
                <td class="table-cell">{{ professores.pqr.denominacao }}</td>
                <td class="table-cell">
                  <input
                    [(ngModel)]="professores.pqr.denominacao"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    class="display-input align-left"
                    type="text"
                  />
                </td>
                <td class="table-cell">
                  <select
                    [(ngModel)]="professores.pqr.tipoNivelFormacao.codTipoNivelFormacao"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    class="align-left display-input">
                    <option *ngFor="let formacao of opcoesFormacao"
                            [ngValue]="formacao.codTipoNivelFormacao">
                      {{ formacao.descricao }}
                    </option>
                  </select>
                </td>
                <td class="table-cell">
                  <input
                    class="display-input text-green align-center"
                    [(ngModel)]="professores.pqr.jornadaTotal"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    appOnlyNumbers
                    type="number"
                  />
                </td>
                <td class="table-cell">
                  <input
                    class="display-input text-green porcentagem-input"
                    [(ngModel)]="professores.pqr.jornadaSemInteracao"
                    (ngModelChange)="ajustarPorcentagemComInteracao(professores)"
                    type="number"
                  />
                </td>

                <td class="table-cell">
                  <input
                    class="display-input text-green"
                    [(ngModel)]="professores.pqr.jornadaComInteracao"
                    (ngModelChange)="ajustarPorcentagemSemInteracao(professores)"
                    type="number"
                  />
                </td>
                <td class="table-cell" colspan="2">
                  <input
                    appPtBrNumber
                    class="display-input text-green"
                    [(ngModel)]="professores.pqr.remuneracaoBrutaMensal"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                  />
                </td>
                <td class="table-cell">
                  <input
                    class="display-input align-center"
                    [value]="formatarMesAnoParaExibicao(professores.pqr.mesAnoReferencia)"
                    (blur)="onMesAnoBlur(professores, $event)"
                    [maskito]="mask_mes_ano"
                    type="text"
                />
                </td>
                <td class="table-cell text-blue align-right">
                  {{ professores.numeroProfessoresPorcentagemDistribuicao.numeroProfessores  | number }}
                </td>
                <td class="table-cell text-blue align-right">
                  {{ professores.numeroProfessoresPorcentagemDistribuicao.porcentagem | number: '1.2-2' }}
                </td>
                <td class="table-cell">
                  <input
                    class="display-input text-blue"
                    [(ngModel)]="professores.pqr.distribuicaoNiveisCarreira"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    type="number"
                  />
                </td>
              </tr>
            </ng-container>
            <tr class="total">
              <th class="align-right" colspan="10">TOTAL</th>
              <th class="align-right text-blue">{{total | number:'1.0-0' }}</th>
              <th class="align-center text-blue">{{numeroDeProfessoresPorNivel | number:'1.2-2' }}</th>
              <th class="align-right text-blue">
                {{ distribuicaoNumeroProfesores | number:'1.0-0' }}%
              </th>
            </tr>
          </ng-container>
        </app-tabela>
        <app-rodape-fonte-nota [foteNota]="notasFonte"> </app-rodape-fonte-nota>
      </div>
    </div>
  </div>
</section>
